.accountDetailsSection {
    display: flex;
    flex-direction: column;
    gap: var(--account-details-section-gap);
    width: 100%;
}
